import { Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { fuseAnimations } from '@fuse/animations';
import { CommonModule } from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';
import { ConfigService } from '../../../services/config.service';
import { FileService } from '../../../services/file.service';
import tinycolor from 'tinycolor2';
import { TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { DrakeSharedService } from '../../../services/drake-shared.service';
import { LanguagesComponent } from '../../../layout/common/languages/languages.component';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    selector: 'app-confirm-email',
    templateUrl: './confirm-email.component.html',
    styleUrls: ['./confirm-email.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        QRCodeModule,
        LanguagesComponent
    ],
    providers: [TranslocoPipe]
})
export class ConfirmEmailComponent implements OnInit {
    backgroundColor: string;
    logoUrl: string;
    logoId: string;
    textColor: string;
    introductionHtml: string;
    customColor: string;
    emailConfirmedText: string = "..."
    introductionCss: string;


    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private sanitizer: DomSanitizer,
        private router: Router,
        private route: ActivatedRoute,
        private fileService: FileService,
        private configService: ConfigService,
        private translocoService: TranslocoService,
        private drakeSharedService: DrakeSharedService,
        private translocoPipe: TranslocoPipe,
        private renderer: Renderer2,


    ) { }

    ngOnInit(): void {

        this.loadBranding('DEFAULT');

        this.route.params.subscribe(params => {
            const userId = params['id'];
            if (userId) {
                this.confirmEmail(userId);
            }
        });
    }


    confirmEmail(userId: string): void {
        this.authService.confirmEmail(userId).subscribe({
            next: (response: any) => {

                if (response.status == "OK") {
                    var text = this.translocoPipe.transform('registration.email.confirmed')
                    this.emailConfirmedText = text;
                    // Redirect to the login page
                    var notification = this.translocoPipe.transform("notification.success.confirmEmail.confirm");
                    this.drakeSharedService.showTemporaryNotification(notification, "success");
                    //this.router.navigate(['/login']);
                    setTimeout(() => window.close(), 5000);
                } else {
                    var text = this.translocoPipe.transform('registration.email.notConfirmed')
                    this.emailConfirmedText = text;
                    var notification = this.translocoPipe.transform("notification.error.confirmEmail.confirm");
                    this.drakeSharedService.showTemporaryNotification(notification, "error");
                    console.error('Email confirmation failed', response.message);
                }
            },
            error: (error: any) => {
                var text = this.translocoPipe.transform('registration.email.notConfirmed')
                this.emailConfirmedText = text;
                var notification = this.translocoPipe.transform("notification.error.confirmEmail.confirm");
                this.drakeSharedService.showTemporaryNotification(notification, "error");
                console.error('Error during email confirmation', error);
            }
        });
    }

    loadBranding(id: string): void {
        console.log("Loading branding with ID:", id);
        this.configService.getBranding(id).subscribe({
            next: (config: any) => {
                console.log("Received branding config:", config);
                if (config) {
                    this.backgroundColor = config.brdColor1 || this.backgroundColor;
                    this.logoId = config.brdLogo1 || this.logoUrl;
                    this.textColor = config.brdColor2 || this.textColor;
                    this.introductionHtml = config.brdSigninHtml || this.introductionHtml;
                    this.customColor = config.brdColor3 || this.customColor;
                    this.introductionCss = config.brdAppCss || this.introductionCss;
                    // Sanitize if needed     
                    const styleElement = this.renderer.createElement('style'); const sanitizedCss = this.sanitizer.sanitize(1, this.introductionCss);
                    this.renderer.setProperty(styleElement, 'textContent', sanitizedCss);
                    this.renderer.appendChild(document.head, styleElement);

                    this.setCustomColor(this.backgroundColor, 'background');
                    this.setCustomColor(this.textColor, 'text');
                    this.setCustomColor(this.customColor, 'custom');

                    if (this.logoId) {
                        this.fileService.readFileAsBase64String(this.logoId).subscribe((result: any) => {
                            console.log("logo ", result);
                            this.logoUrl = result.dataUrl;
                            config.brdLogo1 = result.dataUrl
                            localStorage.setItem('branding', JSON.stringify(config));
                        });
                    } else {
                        localStorage.setItem('branding', JSON.stringify(config));
                    }

                    console.log("Branding saved in localStorage:", localStorage.getItem('branding'));
                } else {
                    console.warn("Branding config is undefined or null");
                }
            },
            error: (error: any) => {
                console.error('Error loading branding:', error);
            },
            complete: () => {
                console.log('Branding loading completed');

                var lang = this.translocoService.getActiveLang();
                if (localStorage.lang) {
                    lang = localStorage.lang;
                }
                this.translocoService.setActiveLang(lang);
                this.translocoService.load(lang).subscribe(a => {
                    this.translocoService.selectTranslation(lang);
                });
            }
        });
    }

    setCustomColor(color: string, name: string): void {
        document.documentElement.style.setProperty(`--${name}-color`, color);
        document.documentElement.style.setProperty(`--${name}-light`, this.lighten(color, 20));
        document.documentElement.style.setProperty(`--${name}-dark`, this.darken(color, 20));
        document.documentElement.style.setProperty(`--${name}-lighter`, this.lighten(color, 40));
        document.documentElement.style.setProperty(`--${name}-darker`, this.darken(color, 40));
    }

    lighten(color: string, percent: number): string {
        return tinycolor(color).lighten(percent).toString();
    }

    darken(color: string, percent: number): string {
        return tinycolor(color).darken(percent).toString();
    }





}
